/* ─────────────────────────────────────────────
   shop-by-game.js  v1
   Upload to: Assets/

   Powers:
     - Predictive search dropdown (match + no-match states)
     - Suggest a game form (submits via fetch to /contact endpoint)
     - FAQ accordion
   ───────────────────────────────────────────── */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-sbg]');
    if (!root) return;

    initSearch(root);
    initFaq(root);
  }

  /* ── SEARCH ───────────────────────────────────── */

  function initSearch(root) {
    var searchEls = root.querySelectorAll('[data-sbg-search]');
    if (!searchEls.length) return;

    // Read shared games data (rendered by Liquid)
    var gamesScript = root.querySelector('[data-sbg-games]');
    var games = [];
    if (gamesScript) {
      try {
        games = JSON.parse(gamesScript.textContent || '[]');
      } catch (e) {
        console.error('[shop-by-game] Could not parse games JSON', e);
      }
    }

    searchEls.forEach(function (el) {
      setupSearch(el, games);
    });
  }

  function setupSearch(searchEl, games) {
    var input = searchEl.querySelector('[data-sbg-search-input]');
    var clearBtn = searchEl.querySelector('[data-sbg-search-clear]');
    var dropdown = searchEl.querySelector('[data-sbg-search-dropdown]');
    var matchesWrap = searchEl.querySelector('[data-sbg-search-matches]');
    var matchesList = searchEl.querySelector('[data-sbg-search-matches-list]');
    var noMatchWrap = searchEl.querySelector('[data-sbg-search-no-match]');
    var queryEl = searchEl.querySelector('[data-sbg-search-query]');
    var suggestBtn = searchEl.querySelector('[data-sbg-search-suggest-btn]');
    var suggestForm = searchEl.querySelector('[data-sbg-search-suggest-form]');
    var suggestGameEl = searchEl.querySelector('[data-sbg-search-suggest-game]');
    var suggestEmailInput = searchEl.querySelector('[data-sbg-search-suggest-email]');
    var suggestSubmit = searchEl.querySelector('[data-sbg-search-suggest-submit]');

    if (!input || !dropdown) return;

    var activeIndex = -1;
    var currentMatches = [];

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function highlightMatch(name, query) {
      if (!query) return escapeHtml(name);
      var lowerName = name.toLowerCase();
      var lowerQuery = query.toLowerCase();
      var idx = lowerName.indexOf(lowerQuery);
      if (idx === -1) return escapeHtml(name);
      return (
        escapeHtml(name.slice(0, idx)) +
        '<em>' + escapeHtml(name.slice(idx, idx + query.length)) + '</em>' +
        escapeHtml(name.slice(idx + query.length))
      );
    }

    function gameIconSvg() {
      return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="11" x2="10" y2="11"/><line x1="8" y1="9" x2="8" y2="13"/><line x1="15" y1="12" x2="15.01" y2="12"/><line x1="18" y1="10" x2="18.01" y2="10"/><path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"/></svg>';
    }

    function arrowIconSvg() {
      return '<svg class="sbg-search-match-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
    }

    function search(query) {
      query = (query || '').trim();
      if (!query) {
        hideDropdown();
        return;
      }

      var lowerQuery = query.toLowerCase();
      var matches = games.filter(function (g) {
        return g.name.toLowerCase().indexOf(lowerQuery) !== -1;
      }).slice(0, 6);

      currentMatches = matches;
      activeIndex = -1;

      showDropdown();

      if (matches.length > 0) {
        renderMatches(matches, query);
        if (matchesWrap) matchesWrap.hidden = false;
        if (noMatchWrap) noMatchWrap.hidden = true;
        if (suggestForm) suggestForm.hidden = true;
      } else {
        if (matchesWrap) matchesWrap.hidden = true;
        if (noMatchWrap) noMatchWrap.hidden = false;
        if (suggestForm) suggestForm.hidden = true;
        if (queryEl) queryEl.textContent = query;
      }
    }

    function renderMatches(matches, query) {
      if (!matchesList) return;
      matchesList.innerHTML = matches.map(function (g, i) {
        return (
          '<a href="/pages/' + escapeHtml(g.handle) + '" class="sbg-search-match" role="option" data-sbg-match-index="' + i + '">' +
          '<span class="sbg-search-game-icon">' + gameIconSvg() + '</span>' +
          '<span class="sbg-search-game-name">' + highlightMatch(g.name, query) + '</span>' +
          arrowIconSvg() +
          '</a>'
        );
      }).join('');
    }

    function showDropdown() {
      dropdown.hidden = false;
    }

    function hideDropdown() {
      dropdown.hidden = true;
      if (suggestForm) suggestForm.hidden = true;
      activeIndex = -1;
    }

    function setActive(index) {
      var items = matchesList ? matchesList.querySelectorAll('.sbg-search-match') : [];
      items.forEach(function (item, i) {
        if (i === index) {
          item.classList.add('is-active');
          item.scrollIntoView({ block: 'nearest' });
        } else {
          item.classList.remove('is-active');
        }
      });
      activeIndex = index;
    }

    // Input events
    input.addEventListener('input', function (e) {
      var val = e.target.value;
      if (clearBtn) clearBtn.hidden = !val;
      search(val);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim()) search(input.value);
    });

    input.addEventListener('keydown', function (e) {
      var items = matchesList ? matchesList.querySelectorAll('.sbg-search-match') : [];

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (items.length === 0) return;
        var next = activeIndex + 1;
        if (next >= items.length) next = 0;
        setActive(next);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (items.length === 0) return;
        var prev = activeIndex - 1;
        if (prev < 0) prev = items.length - 1;
        setActive(prev);
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && currentMatches[activeIndex]) {
          e.preventDefault();
          window.location.href = '/pages/' + currentMatches[activeIndex].handle;
        } else if (currentMatches.length === 1) {
          e.preventDefault();
          window.location.href = '/pages/' + currentMatches[0].handle;
        }
      } else if (e.key === 'Escape') {
        input.value = '';
        if (clearBtn) clearBtn.hidden = true;
        hideDropdown();
        input.blur();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        hideDropdown();
        input.focus();
      });
    }

    // Hide dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!searchEl.contains(e.target)) {
        hideDropdown();
      }
    });

    // Suggest button → open form
    if (suggestBtn && suggestForm) {
      suggestBtn.addEventListener('click', function () {
        if (suggestGameEl) suggestGameEl.textContent = input.value.trim();
        if (noMatchWrap) noMatchWrap.hidden = true;
        suggestForm.hidden = false;
        if (suggestEmailInput) suggestEmailInput.focus();
      });
    }

    // Suggest submit
    if (suggestSubmit) {
      suggestSubmit.addEventListener('click', function () {
        var gameName = input.value.trim();
        if (!gameName) return;
        var email = suggestEmailInput ? suggestEmailInput.value.trim() : '';
        submitSuggestion(gameName, email, function () {
          hideDropdown();
          if (suggestEmailInput) suggestEmailInput.value = '';
          input.value = '';
          if (clearBtn) clearBtn.hidden = true;
          showSuccessToast();
        });
      });
    }
  }

  /* ── SUGGEST SUBMISSION ───────────────────────── */

  function submitSuggestion(gameName, email, onDone) {
    // Submit to Shopify's built-in /contact endpoint.
    // Goes to the shop owner's email (set in Settings → Notifications → Customer contact).
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', email || 'Shop By Game suggestion');
    formData.append('contact[email]', email || 'noreply@geekapc.com');
    formData.append('contact[subject]', 'Shop By Game — game suggestion: ' + gameName);
    formData.append('contact[body]', 'A visitor suggested adding "' + gameName + '" to the Shop By Game tool.\n\nVisitor email: ' + (email || '(not provided)') + '\n\nSubmitted from: ' + window.location.href);

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).then(function () {
      // Shopify returns HTML, not JSON, but as long as the POST went through we're good.
      if (onDone) onDone();
    }).catch(function (err) {
      console.error('[shop-by-game] Suggest submission failed', err);
      if (onDone) onDone();
    });
  }

  function showSuccessToast() {
    var toast = document.querySelector('[data-sbg-suggest-success]');
    if (!toast) return;
    toast.hidden = false;
    setTimeout(function () {
      toast.hidden = true;
    }, 4000);
  }

  /* ── FAQ ──────────────────────────────────────── */

  function initFaq(root) {
    var toggles = root.querySelectorAll('[data-sbg-faq-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ── BOOT ─────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
